import ExpandedLoopSlider from "./modules/components/ExpandedLoopSlider.class";
const {jQuery: $} = window;

$(window).on('load', () => {
    new ExpandedLoopSlider({
        "$element": $(".elementor-widget-expanded-loop-carousel")
    });
});

